export default __webpack_public_path__ + "static/media/lupa.d4061697.png";